import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";

import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_2 } from "./ZPartnerLSCUrls";

export class LSC_SigninReplaceAction extends Component {
    static displayName = LSC_SigninReplaceAction.name;

    constructor(props) {
        super(props);
        this.state = {
            message: "",
            submitting: false,
            actionid: ""
        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/lsc/style_01.css",
            "/css/lsc/style_02.css",
            "/css/lsc/style_03.css",
            "/css/lsc/691208892_en-US.css",
            "/css/lsc/line_my_card.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Read query string parameters
        const params = new URLSearchParams(window.location.search);
        const actionid = params.get("actionid");
        // If any required parameter is missing, redirect to error page
        if (!actionid) {
            sessionStorage.setItem("lscErrorMsg", "Missing param action!!");
            window.location.replace("/line_err01");
            return;
        }

        this.setState({
            actionid: actionid
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "LSC_Replace_Action";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            // keep reference for removeEventListener later
            this.handlePopState = () => {
                const hashLocation = window.location.hash;
                const hashSplit = hashLocation.split("#!/");
                const hashName = hashSplit[1];

                if (hashName !== "") {
                    const hash = window.location.hash;
                    if (hash === "") {
                        window.location = Redirect_Url_2;
                        return false;
                    }
                }
            };

            window.addEventListener("popstate", this.handlePopState);

            // same as original: push fake state into history
            window.history.pushState("forward", null, "./#forward");
        }
        // #endregion
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        const { actionid } = this.state;

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        // Payload for Line Signin
        const payload = {
            ActionId: actionid,            
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLSCSigninReplace`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                sessionStorage.setItem("signinMessage", message);

                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                switch (message) {
                    case "success":
                        window.location.replace("/line_signin_replace_action_success");
                        break;                    
                    default:
                        window.location.replace("/");
                        break;
                }
            } else {                
                document.body.classList.remove("wait-cursor");

                sessionStorage.setItem("lscErrorMsg", "Error occur !!");
                window.location.replace("/line_err01");
            }
        } catch (error) {
            console.error("Error during LineSignin API:", error);
            this.setState({
                loginstatus: "Unexpected error occurred",
                submitting: false
            });

            document.body.classList.remove("wait-cursor");
        }
    };

    render() {
        const {
            submitting
        } = this.state;

        return (
            <div id="js-content" className="account_area new_sr line_my_card">
                <ZPartnerLSC0Header />

                <div className="height-100 ">
                    <main id="content" className="base___8qAal height-100 flex flex-column " role="main">
                        <div className="sb-headerCrate flex flex-column bg-white  flex-shrink-none">
                            <div className="lg-flex flex-column base___46s3P">
                                <div className="flex flex-grow flex-column ">
                                    <div className="container--headerCrate sb-headerCrate--content size12of12 pt3">
                                        <h2 className="sb-heading sb-heading--medium Sarabun_fontthai mb2">ยืนยันการใช้ Starbucks® Rewards บัญชีนี้กับบัญชี LINE ใหม่</h2>
                                        <h2 className="sb-heading sb-heading--xsmall">Confirm to link this Starbucks<sup>®</sup> Rewards account with the new LINE account.</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sb-contentCrate flex-grow ">
                            <div className="relative flex-auto">
                                <div className="flex-auto">
                                    <div>
                                        <div>
                                            <div className="padding___2PNk5 mx-auto narrow___pLMqt pb5">
                                                <form onSubmit={this.handleSubmit}>
                                                    <div className="field mb2">
                                                        <div className="field__inputWrapper">
                                                            <p className="text-md mb4 Sarabun_fontthai">หากท่านต้องการใช้บัญชี LINE นี้ ผูกกับ Starbucks®  Rewards ของท่าน กรุณากดยืนยัน กรณีที่ท่านกดยืนยัน บัญชี LINE เดิม จะไม่สามารถใช้งาน LINE Starbucks Card ได้</p>
                                                            <p className="text-sm mb4">To confirm to link this LINE account with your Starbucks<sup>®</sup> Rewards, please click the button below. After confirming, the existing LINE account will not be access your LINE Starbucks Card.</p>
                                                        </div>
                                                        <div className="flex justify-end mt6">
                                                            <button
                                                                className="btn btn-primary rounded-pill px-4"
                                                                name="theButton"
                                                                disabled={submitting}
                                                            >
                                                                ยืนยัน<br />
                                                                Confirm
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr aria-hidden="true" className="sb-rule sb-rule--thin mb4 lg-mb6" />
                            <ZPartnerLSC0Footer />
                        </div>
                    </main>
                </div>
            </div>

        );
    }
}
